import React from 'react';
import Text, { H3 } from '@dbk/ui-text';
import NavigationArrow from '../../../../../../src/components/common/navigation-arrow';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import { downloadPdf } from '../../../../../../src/muster/utils/downloader';
import config from '../../../../../../src/data/settings.json';

import './style.css';
import isEnterorSpaceKeyPressed from '../../../../../../src/utils/isEnterorSpaceKeyPressed';

export default (props) => {
  const { i18n: { messages }, loginTerms: { pdfLinkData } } = props;
  const remoteUrl = window.location.href.split('ebanking')[0] + config.environments.relative.remoteUrl;
  const termsLink = remoteUrl + pdfLinkData.tcPdfLink;
  const privacyLink = remoteUrl + pdfLinkData.paPdfLink;

  // const termsLink = "https://int6.mywealthasia.intranet.db.com/ebanking" + pdfLinkData.tcPdfLink;
  // const privacyLink = "https://int6.mywealthasia.intranet.db.com/ebanking" + pdfLinkData.paPdfLink;

  if (pdfLinkData.tcPdfLink == null || pdfLinkData.paPdfLink == null) {
    return <Text>{messages['app.terms.linkError']}</Text>;
  }
  const items = [{
    "link": termsLink,
    "fileName": pdfLinkData.tcPdfFileName,
    "nameID": 'app.terms.termsPdf'
  },
  {
    "link": privacyLink,
    "fileName": pdfLinkData.paPdfFileName,
    "nameID": 'app.terms.privacyPdf'
  }];
  // let onDownload = item =>  download(item.link, item.fileName , 'application/pdf');

  const onDownload = (item, e) => { 
    if(isEnterorSpaceKeyPressed(e)){
      downloadPdf(item.link, item.fileName);
    }
  }

  return (
    <div className="term-condition">
      <div className="pad-bottom-20">
        <div>
          <NavigationList  >
            {
              items && items.map((item) => (
                <NavigationListItem
                  hasArrow key={messages[item.nameID]} onKeyDown={(e) => onDownload(item, e)} onClick={() => onDownload(item)} label={messages['app.downloads.download']+ " " +messages[item.nameID]+ " " +messages['app.common.button']} tabIndex={-1}>

                  <Text size="large" tabIndex={0}>{messages[item.nameID]}</Text>

                </NavigationListItem>

              ))
            }
          </NavigationList>
        </div>
      </div>
    </div>
  );
};
